import store from '../index'

export const dispatchError = (error, audioType) => {
  store.dispatch({ type: 'DISPATCH_ERROR', error, audioType })
}

export const dispatchMessage = (message, audioType) => {
  store.dispatch({ type: 'DISPATCH_MESSAGE', message, audioType })
}
